/* YM effects — "shot metal sign" button hit: a bullet hole appears at the
   click point and the button warps like a dented metal sign. */
(function () {
  var SEL = '.ymh__btn, .ympp__cta-btn, .ym-shootable, [data-shot]';
  var SVG =
    '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" aria-hidden="true">' +
    '<g stroke="#e6e2d7" stroke-width="1.1" stroke-linecap="round" opacity="0.9">' +
    '<path d="M24 24 L33 6"/><path d="M24 24 L44 15"/><path d="M24 24 L45 27"/>' +
    '<path d="M24 24 L38 41"/><path d="M24 24 L25 47"/><path d="M24 24 L9 40"/>' +
    '<path d="M24 24 L3 26"/><path d="M24 24 L7 10"/><path d="M24 24 L21 3"/>' +
    '</g>' +
    '<circle cx="24" cy="24" r="10" fill="#cbc6b8"/>' +
    '<circle cx="24" cy="24" r="8.5" fill="#0a0a09"/>' +
    '<circle cx="21.5" cy="21.5" r="3" fill="#000"/>' +
    '</svg>';

  function shoot(btn, x, y) {
    if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
    var b = document.createElement('span');
    b.className = 'ym-bullet';
    b.style.left = x + 'px';
    b.style.top = y + 'px';
    b.innerHTML = SVG;
    btn.appendChild(b);
    // re-trigger the warp each time
    btn.classList.remove('ym-shot');
    void btn.offsetWidth;
    btn.classList.add('ym-shot');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(SEL);
    if (!btn) return;
    var r = btn.getBoundingClientRect();
    var x = e.clientX - r.left;
    var y = e.clientY - r.top;
    if (!e.clientX && !e.clientY) { x = r.width / 2; y = r.height / 2; } // keyboard activation
    shoot(btn, x, y);

    // If it's a link, let the hit play out briefly before navigating.
    var href = btn.tagName === 'A' ? btn.getAttribute('href') : null;
    var newTab = btn.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey;
    if (href && !newTab && !btn.dataset.shotBusy) {
      e.preventDefault();
      btn.dataset.shotBusy = '1';
      setTimeout(function () { window.location = href; }, 600);
    }
  });
})();
